import React, { useEffect, useState, useRef } from "react";
import { cart } from "../Reducers/Cart.reducer";
import { useDispatch } from "react-redux";
import { translate } from "../Services/translation";
import MiniCartProduct from "./MiniCart.Product";
import SideMenu from "./SideMenu";
import MiniCartErrorMessage from "./MiniCart.ErrorMessage";
import { show } from "../Actions/LightboxImages.action";
import { shouldShowErrorMessage } from "../Actions/Cart.action";
import Badge from "./Badge";
import AlgoliaRecommend from "./Algolia/AlgoliaRecommend";

const MiniCart = (props) => {
  const {
    uspText,
    orderRows,
    grandTotal,
    isShippingSet,
    deliveryCost,
    discount,
    shippingInfoText,
    quantity,
    checkoutUrl,
    visible,
    shouldClose,
    showMiniCart,
    onClosed,
    updateRow,
    addedTooManyProducts,
    isCheckoutPage,
    paymentProvidersImageUrl,
  } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    if (addedTooManyProducts) {
      setTimeout(() => {
        if (addedTooManyProducts) {
          dispatch(shouldShowErrorMessage(false));
        }
      }, 2500);
    }
  }, [addedTooManyProducts]);
  const handleCloseClick = () => {
    dispatch(shouldShowErrorMessage(false));
  };
  const header = (
    <>
      {translate("minicart.title")}&nbsp;
      <span className="cart-container__quantity-text">({quantity})</span>
    </>
  );
  const footer = (
    <div className="cart-container__footer">
      {discount && (
        <div className="cart-container__footer-price-row cart-container__footer-price-row--discount">
          <div>{translate("checkout.discount")}</div>
          <div>- {discount}</div>
        </div>
      )}
      {isShippingSet && (
        <div className="cart-container__footer-price-row cart-container__footer-price-row--shipping">
          <span>
            {translate("checkout.shipping")}
            {shippingInfoText ? <span> ({shippingInfoText})</span> : ""}
          </span>
          <span>{deliveryCost}</span>
        </div>
      )}
      <div className="cart-container__footer-price-row cart-container__footer-price-row--total">
        <div>{translate("minicart.total")}</div>
        <div>{grandTotal}</div>
      </div>
      {quantity != 0 && (
        <a
          href={checkoutUrl}
          className="btn btn--large btn--primary btn--fullwidth"
        >
          {translate("minicart.checkout")}
        </a>
      )}
      <div className="cart-container__footer--extra-info">
        {!!uspText && (
          <span>
            <i className="ph-package"></i> {uspText}
          </span>
        )}
        <div className="cart-container__footer--extra-info--logos">
          {paymentProvidersImageUrl && (
            <img src={paymentProvidersImageUrl} alt="Payment providers" />
          )}
        </div>
      </div>
    </div>
  );

  const showHideClass = addedTooManyProducts
    ? "minicart-errormessage show-error-message"
    : "minicart-errormessage hide-error-message";

  // Props reference to prevent AlgoliaRecommend from re-mounting and disappear on cart changes
  const algoliaPropsRef = useRef(null);

  const getAlgoliaFallbackParameters = () => {

    const facetFilters = __litium.algoliaSettings.cart.fallbackFacetFilters;
    const numericFilters = __litium.algoliaSettings.cart.fallbackNumericFilters;

    if(!facetFilters && !numericFilters) {
      return undefined;
    }

    // Fallback parameters are defined on Litium website in format
    // param:value,param2:value2

    const parseFacetFilter = (filter) => {
      if (!filter) return [];
      return filter.split(",").map((item) => {
        if(item) return item.trim();
      });
    }

    const filter = {
      facetFilters: parseFacetFilter(facetFilters),
      numericFilters: parseFacetFilter(numericFilters),
    };
    return filter;
  };

  const algoliaRecommend = () => {
    const algoliaRow =
      props.algoliaRecommend &&
      props.algoliaRecommend.rows &&
      props.algoliaRecommend.rows[0];

    if (!algoliaRow) return null;

    // Freeze props on first render to prevent Algolia TrendingItems from losing DOM
    if (!algoliaPropsRef.current) {
      const objectIds = algoliaRow.objectIds && algoliaRow.objectIds.join(",");
      algoliaPropsRef.current = {
        ...algoliaRow,
        objectIds,
        recommendationType: algoliaRow.typeId,
        showBuyButton: true,
        slidesPerView: 2,
        fallbackParameters: getAlgoliaFallbackParameters(),
      };
    }

    return (
      <div className="cart-container__item">
        <div className="cart-container__item-recommend">
          <AlgoliaRecommend {...algoliaPropsRef.current} />
        </div>
      </div>
    );
  };

  return (
    <div className="cart cart--mini">
      <a className="header__link-block" onClick={showMiniCart}>
        <i className="icon-bag">
          <Badge count={quantity} className="cart__quantity" />
        </i>
      </a>
      <SideMenu
        id="MiniCart"
        header={header}
        footer={footer}
        open={visible}
        onClosed={onClosed}
        className="cart-container"
      >
        <>
          <MiniCartErrorMessage css={showHideClass} close={handleCloseClick} />

          <div className="cart-container__items">
            {orderRows.length > 0 ? (
              orderRows.map((row) => (
                <MiniCartProduct
                  key={row.rowSystemId}
                  product={row}
                  decreaseQuantity={() =>
                    updateRow(row.rowSystemId, row.quantity - 1, isCheckoutPage)
                  }
                  increaseQuantity={() =>
                    updateRow(row.rowSystemId, row.quantity + 1, isCheckoutPage)
                  }
                  deleteRow={() =>
                    updateRow(row.rowSystemId, 0, isCheckoutPage)
                  }
                />
              ))
            ) : (
              <div className="cart-container__item">
                {translate("minicart.empty")}
              </div>
            )}

            {algoliaRecommend()}
          </div>
        </>
      </SideMenu>
    </div>
  );
};

export default MiniCart;
